<template>
  <div class="course_wrapper">
    <el-container>
      <el-header class="prepare-header">
        <el-page-header style="margin-top: 15px; margin-left: 15px" @back="goBack" :content="curriculumMaterial.title">
        </el-page-header>
      </el-header>
      <el-container>
        <el-aside class="leftpanel">
          <el-menu default-active="1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :collapse="isCollapse" @select="handleSelect">
            <el-menu-item index="1">
              <i class="el-icon-data-analysis"></i>
              <span slot="title">课件</span>
            </el-menu-item>
            <el-menu-item index="2" :disabled="curriculumMaterial.lessionPlanUrl == ''">
              <i class="el-icon-document"></i>
              <span slot="title">教案</span>
            </el-menu-item>
            <el-menu-item v-if="false" disabled index="3">
              <i class="el-icon-notebook-1"></i>
              <span slot="title">笔记</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="container">
          <container :curriculumMaterial="curriculumMaterial" :tchPlanId="tchPlanId"></container>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getPrepareCurrculumMaterial } from '@/api/educational.js'
import container from './container.vue'
export default {
  name: 'prepare-lessons',
  components: {
    container,
  },
  data() {
    return {
      isCollapse: true,

      curriculumMaterial_id: '',
      curriculumMaterial: {},
      tchPlanId: '', //讲次ID
      backname: '',
      classid: '',
      routeQuery: null,
    }
  },

  mounted() {
    document.getElementsByClassName('header-menu-container')[0].style.display =
      'none'
    this.routeQuery = this.$route.query
    this.curriculumMaterial_id = this.$route.query.curriculumMaterial_id
    this.backname = this.$route.query.backname
    this.classid = this.$route.query.classid
    this.tchPlanId = this.$route.query.tchPlanId

    console.log('备授课收到')
    console.log(this.curriculumMaterial_id)
    console.log(this.tchPlanId)

    this.getPrepareCurrculumMaterial()
  },

  methods: {
    goClass() { },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    //备课返回
    goBack() {
      console.log(this.$route.query.end_class_state)
      if (this.$route.query.end_class_state === 0) {
        this.$router.push({
          name: this.backname,
          query: {
            type1: this.$route.query.type1,
            class_id: this.classid,
            end_class_state: this.$route.query.end_class_state,
            // id: this.$route.query.curriculumMaterial_id,
            id: this.$route.query.id,
          },
        })
      } else {
        this.$router.push({
          name: this.backname,
          query: {
            class_id: this.classid,
            // id: this.$route.query.curriculumMaterial_id,
            id: this.$route.query.id,
            scrollToHeight: this.$route.query.scrollToHeight,
          },
        })
      }
    },

    handleSelect(key) {
      if (key === '1') {
        this.$router.push({
          name: 'prepare-ppt',
          query: this.routeQuery,
        })
      } else if (key === '2') {
        this.$router.push({
          name: 'prepare-pdf',
          query: this.routeQuery,
        })
      } else if (key === '3') {
        this.$router.push({
          name: 'code-classroom-stu',
          query: this.routeQuery,
        })
      } else {
        this.$router.push({
          name: 'home',
        })
      }
    },

    //根据ID获得课程内容
    getPrepareCurrculumMaterial() {
      getPrepareCurrculumMaterial({
        currMatId: this.curriculumMaterial_id,
        tchPlanId: this.tchPlanId,
      }).then((res) => {
        console.log('备授课返回的课程信息')
        console.log(res)
        this.curriculumMaterial = res.curriculumMaterial
      })
    },
  },
}
</script>

<style>
.header-menu-container {
  display: none;
}
</style>

<style lang="scss" scoped>
.course_wrapper {
  margin: 10px;
  border-radius: 5px;
  background: white;

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    min-height: 400px;
    height: calc(100vh - 181px);
    border-right: 0;
  }

  .el-menu {
    border-right: 0;
  }

  .el-main {
    padding: 0;
    overflow: hidden;
  }

  .prepare-header {
    height: 40px !important;
    line-height: 40px;
    padding: 0 !important;
  }

  .leftpanel {
    width: auto !important;
    height: calc(100vh - 181px);
    margin-top: 15px;
  }
}
</style>
